// extracted by mini-css-extract-plugin
module.exports = {"legendContainer":"nczHOeV5","legendContainerMultipleRows":"uNfeauZY","legendItem":"sf8IDKsP","legendColor":"ZXHg48zr","multiRowWrapper":"_65nmnnSn"};